// Sync this with the backend enum
// src\app\Enums\SuspensionReasonsEnums.php
export const SUSPENSION_REASONS = Object.freeze({
  SPAM_REQUESTS: Object.freeze({
    value: 'spam-requests',
    label: 'Spam Requests',
  }),
  INAPPROPRIATE_BEHAVIOR: Object.freeze({
    value: 'inappropriate-behavior',
    label: 'Inappropriate Behavior',
  }),
});

export const SUSPENSION_REASONS_LIST = Object.freeze([
  SUSPENSION_REASONS.SPAM_REQUESTS,
  SUSPENSION_REASONS.INAPPROPRIATE_BEHAVIOR,
]);